module.exports = __webpack_public_path__ + "static/img/jiaying-card.f2f9e63a.png";